const { lock } = require('tua-body-scroll-lock');
const cart = require('../cart/cart');
const { wishlistHandler } = require('../product/wishlist').methods;
const { handleInitialExpandedClass } = require('../animations/dropDownCheck');
const { EventBus, EventBusConfig } = require('../vue');
const getAnalyticsEventCenter = require('../common/getAnalyticsEventCenter');

const analyticsEventCenter = getAnalyticsEventCenter();

// const isBreakpointMobile = require('../common/utils/isMatchedBreakpoint');

let updateMiniCart = true;

// function setMinicartHeights(inital = false) {
//   const headerPopup = $('.header-popup.cart-container');
//
//   if (!isBreakpointMobile.matches()) {
//     const initialHeight = inital ? headerPopup.outerHeight() : 0;
//     headerPopup.css('height', '');
//     let totalHeight = parseInt(headerPopup.css('padding-top'), 10)
//       + parseInt(headerPopup.css('padding-bottom'), 10);
//     headerPopup.children().each(function sumChildrenHeight() {
//       if ($(this).is(':visible') && $(this).css('position') !== 'absolute') {
//         totalHeight += $(this).outerHeight(true); // true = include margins
//       }
//     });
//     const newHeight = totalHeight > initialHeight
//       ? `${totalHeight}px`
//       : `${initialHeight}px`;
//     headerPopup.css('height', newHeight);
//   } else {
//     headerPopup.css('height', '');
//   }
// }

function handleInitialExpanded(container) {
  const dropDownCheckButton = $('.cart-option--personalize .drop-down-check__button', container);
  const dropDownCheckContent = $('.cart-option--personalize .interaction--expand', container);
  handleInitialExpandedClass(dropDownCheckButton, dropDownCheckContent);
}

/**
 * Check whether the minicart is open
 * @returns {boolean} true if the popup is open
 */
function isMinicartOpen() {
  const minicartPopUp = document.querySelector('.minicart-popup.header-popup');
  return minicartPopUp?.classList.contains('header-popup--show') ?? false;
}

function setViewportHeightVar() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

module.exports = function miniCartExports() {
  cart.init();

  setViewportHeightVar();

  let oldCount;

  $('.minicart').on('count:update', (event, count) => {
    const isVueNode = '__vue__' in event.target;
    if (isVueNode) return; // Animation in vue minicart is managed by component
    const $minicart = $(event.target);
    const $minicartNew = $('.new', $minicart);
    const $minicartOld = $('.old', $minicart);
    oldCount = parseInt($minicartNew.text(), 10);

    if (count && $.isNumeric(count.quantityTotal)) {
      $minicartOld.text(oldCount);
      $minicart.removeClass('change-2').addClass('change-1');

      setTimeout(() => {
        $minicartNew.text(count.quantityTotal);

        requestAnimationFrame(() => {
          $minicart.removeClass('change-1').addClass('change-2');
        });
      }, 100);
    }
  });

  $('body').on('click', '.cart__add-to-wishlist', (e) => {
    const { pid } = e.currentTarget.dataset;
    const { getVariationGroupId } = require('../common/helpers/productIdHelpers');
    const { findProductInCart, getCartFromLocalStorage } = require('../cart/localCart');
    const cartFromLocalStorage = getCartFromLocalStorage();
    const product = findProductInCart(pid, cartFromLocalStorage);
    const variationGroupId = getVariationGroupId(pid);
    wishlistHandler(
      e.currentTarget,
      product,
      variationGroupId,
    );

    const isCartButton = e.currentTarget.closest('.cart-page');
    if (isCartButton) {
      updateMiniCart = true;
    }
  });

  $('body').on('header-popup:hide', () => {
    document.body.classList.remove('body--cart');
  });

  $('body').on('wishlist-heart:updated', () => {
    updateMiniCart = true;
  });

  $('.header-group').on('touchstart click', '.minicart', (event) => {
    event.preventDefault();
    event.stopPropagation();
    const minicartContent = document.querySelector('.minicart-content');

    if (minicartContent !== null) {
      document.body.classList.add('body--cart');
      if (gaInfo.cart_total_items >= 1) {
        // Send info for Analytics: Cart popup opens by clicking icon
        analyticsEventCenter.publish(
          analyticsEventCenter.EVENTS.checkoutCartViewed,
        );
      }
      if (isMinicartOpen()) {
        $('body').trigger('header-popup:hide');
        return;
      }
      if (!updateMiniCart) {
        $('body').trigger('header-popup:show', '.minicart-content .header-popup');
        $('body').trigger('minicart:show');
        return;
      }

      const url = $('.minicart-content').data('action-url');
      $.get(url, (data) => {
        $('.minicart-content').empty();
        $('.minicart-content').append(data);
        updateMiniCart = false;
        $('body').trigger('header-popup:show', '.minicart-content .header-popup');
        $('body').trigger('minicart:show');
        $('body').trigger('save-for-later:update');
        EventBus.$emit(EventBusConfig.commands.cart.createRecommendationVueInstances);
      });
    }
  });

  $('body').on('change', '.minicart .quantity', function onMiniCartIconQuantityChange() {
    if ($(this).parents('.bonus-product-line-item').length && $('.cart-content').length) {
      window.location.reload();
    }
  });

  $('body').on('cart:update product:afterAddToCart', () => {
    updateMiniCart = true;
    if (isMinicartOpen() || cart.isCartPage()) {
      /* Since there can be an slider of recommended products inside the cart,
       * new products can be added when the minicart is opened. So, the cart
       * must be updated when a new product is added and the popup is open or
       * the cart page is visited */
      $('body').trigger('cart:do-update');
    }
    // setTimeout(setMinicartHeights, 500); // after productCard animation ends
  });

  $('body').on('cart:do-update', () => {
    if (updateMiniCart) {
      const url = $('.cart-content').data('update-url');
      $.get(url, (data) => {
        $('.cart-container').each(function updateEachCartContent() {
          const cartContent = $('.cart-content', this);
          cartContent.replaceWith(data);
          updateMiniCart = false;
          handleInitialExpanded($('.cart-content', this));
        });
        EventBus.$emit(EventBusConfig.commands.cart.createRecommendationVueInstances);

        if (isMinicartOpen() || cart.isCartPage()) {
          $('body').trigger('cart:do-after-update');
        }
      });
    }
  });

  $('body').on('minicart:show cart:toggleTab byl:tabs.shown cart:do-after-update', () => {
    lock(Array.from(document.querySelectorAll(
      '.cart-content, '
      + '.cart-content__scrolling-area, '
      + '.cart-content__scrolling-area-fullcart, '
      + '.cart-content__scrolling-area.cart-content__scrolling-area-fullcart, '
      + '.wishlist-container, '
      + '.wishlist-container__scrolling-area, '
      + '.save-for-later-container, '
      + '.save-for-later-container__scrolling-area' // eslint-disable-line comma-dangle
    )));
    $('.cart-content').each(function updateEachCartContent() {
      handleInitialExpanded($(this));
    });
  });

  $(window).resize(() => {
    setViewportHeightVar();
  //   setMinicartHeights();
  });
};
